import { api } from "./api"

type Page<T> = {
  data: T[]
  pagination?: { hasMore?: boolean; nextCursor?: string | null }
}

// Generic Quickback list routes clamp `limit` to 100 rows/page server-side, so
// a `limit: 500` request silently returns the first 100. Walk every page for
// surfaces that must show the whole event, following the keyset cursor. Pass
// `sort` / `order` as usual (omit for the server default, createdAt desc): the
// server appends `id` as a final tiebreaker on every cursor page, so rows that
// tie on the sort column are never skipped or repeated across page boundaries.
export async function listAll<T>(
  path: string,
  params: Record<string, string | number | boolean | undefined>,
): Promise<T[]> {
  const rows: T[] = []
  let cursor: string | undefined
  for (;;) {
    const page = await api<Page<T>>(path, {
      searchParams: { ...params, limit: 100, cursor },
    })
    rows.push(...page.data)
    cursor = page.pagination?.nextCursor ?? undefined
    if (!page.pagination?.hasMore || !cursor || page.data.length === 0) return rows
  }
}

/** listAll wrapped in the `{ data }` list envelope query caches already hold. */
export async function listAllData<T>(
  path: string,
  params: Record<string, string | number | boolean | undefined>,
): Promise<{ data: T[] }> {
  return { data: await listAll<T>(path, params) }
}
